(() => {
  // ============================================================
  // 1. GUARD: blocca cart:change senza sections (BOGOS, ecc.)
  // ============================================================

  // Strategia A: capture-phase listener sul document.
  // Intercetta l'evento PRIMA che arrivi al CartDrawer.
  document.addEventListener('cart:change', (event) => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const sectionId = cartDrawer.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    const sections = event?.detail?.cart?.sections;

    if (!sections || !sections[sectionId]) {
      event.stopImmediatePropagation();
      // Forza un refresh completo del cart drawer dal server.
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }, true);

  // Strategia B: prototype patch del CartDrawer come fallback.
  const applyCartDrawerGuard = () => {
    const CartDrawer = window.customElements.get('cart-drawer');
    if (!CartDrawer || CartDrawer.__sectionsGuardPatched) return false;

    const original = CartDrawer.prototype._onCartChanged;
    CartDrawer.prototype._onCartChanged = async function (event) {
      const sectionId = this.closest('.shopify-section')?.id?.replace('shopify-section-', '');
      const sections = event?.detail?.cart?.sections;
      if (!sections || !sections[sectionId]) {
        return;
      }
      return original.call(this, event);
    };
    CartDrawer.__sectionsGuardPatched = true;
    return true;
  };

  // Tenta di applicare il guard subito; se non c'è ancora, riprova
  // ai vari milestones di caricamento.
  if (!applyCartDrawerGuard()) {
    document.addEventListener('DOMContentLoaded', applyCartDrawerGuard);
    window.addEventListener('load', applyCartDrawerGuard);
    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined('cart-drawer').then(applyCartDrawerGuard);
    }
  }

  // ============================================================
  // 2. Pulsanti +/- nei <line-item-quantity>
  // ============================================================
  // Event delegation sul document: sopravvive a innerHTML refresh
  // del cart drawer.

  document.addEventListener('click', (event) => {
    const button = event.target.closest('line-item-quantity > button');
    if (!button) return;

    const lineItemQuantity = button.parentElement;
    const input = lineItemQuantity.querySelector('input');
    if (!input) return;

    const buttons = lineItemQuantity.querySelectorAll(':scope > button');
    const isFirst = buttons[0] === button;
    const isLast = buttons[buttons.length - 1] === button;

    if (isFirst) {
      input.stepDown();
    } else if (isLast) {
      input.stepUp();
    } else {
      return;
    }

    // Il <line-item-quantity> ascolta già 'change' e fa la chiamata API.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // ============================================================
  // 3. Custom element <line-item-remove>
  // ============================================================

  if (!window.customElements.get('line-item-remove')) {
    class LineItemRemove extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this._onRemoveLinkClicked);
      }

      _onRemoveLinkClicked(event) {
        const link = event.target.closest('a');
        if (!link || !link.href.includes('/cart/change')) return;
        event.preventDefault();
        const url = new URL(link.href);
        this._changeLineItemQuantity(
          url.searchParams.get('id'),
          parseInt(url.searchParams.get('quantity'))
        );
      }

      async _changeLineItemQuantity(lineKey, targetQuantity) {
        if (window.themeVariables.settings.pageType === 'cart') {
          window.location.href = `${Shopify.routes.root}cart/change?id=${lineKey}&quantity=${targetQuantity}`;
          return;
        }

        const lineItem = this.closest('line-item');
        lineItem?.dispatchEvent(new CustomEvent('line-item:will-change', {
          bubbles: true,
          detail: { targetQuantity }
        }));

        const sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        const cartContent = await (await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: lineKey,
            quantity: targetQuantity,
            sections: sectionsToBundle
          })
        })).json();

        const lineItemAfterChange = cartContent.items.filter(li => li.key === lineKey);

        lineItem?.dispatchEvent(new CustomEvent('line-item:change', {
          bubbles: true,
          detail: {
            quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0].quantity,
            cart: cartContent
          }
        }));

        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart: cartContent
          }
        }));
      }
    }

    window.customElements.define('line-item-remove', LineItemRemove);
  }
})();